module.exports = __webpack_public_path__ + "img/invoice-template-nz.72796c6.webp";